export function getEnvironmentName(env: string): string {
    return (env || '').toLowerCase();
}

export function isNonProduction(env: string): boolean {
    const name = getEnvironmentName(env);
    return !!name && name !== 'production';
}

export function getEnvironmentSidebarColor(env: string): string {
    const name = getEnvironmentName(env);
    if (!name || name === 'production') return 'black';
    return 'light';
}

export function getEnvironmentBgColor(env: string): string {
    const name = getEnvironmentName(env);
    if (!name || name === 'production') return '#212120';
    return '#dee2e6';
}

export function getEnvironmentBannerColor(env: string): string {
    switch (getEnvironmentName(env)) {
        case 'staging': return '#f96332';
        case 'development': return '#2CA8FF';
        default: return '#FF3636';
    }
}
